import React from 'react';
import InfoDetail from './InfoDetail';
export default (props) => {
  return <InfoDetail {...props} />;
};
